'use strict';

const orderBy = require('lodash/orderBy');
const get = require('lodash/get');
const sortBy = require('lodash/sortBy');
const PropTypes = require('prop-types');
const Moment = require('moment');

const Globals = require('../../../app/globals');

/*  Sort Util - A utility for sorting object arrays
    - Components use 'sort object' as part of their state to specify the object key used for sorting, asc or desc & the type of data the key is
    sort object format:
    {
        type: one of the type specified by Globals.sort.type,
        asc: Boolean, is ascending?,
        key: in object array, the key that is used for sorting
        alt_key: in object array, the key that is used for sorting IF value for key is not present
        override_key: in object array, the key that is ALWAYS used for sorting if provided. overrides key & alt_key
    }

*/

const SortUtil = {
        SortObjPropType: PropTypes.shape({
            type: PropTypes.string.isRequired,
            asc: PropTypes.bool,
            key: PropTypes.string.isRequired
        }),

        //format functions for sorting
        formatString: function(str) {
            if (!str) {
                return '';
            }

            return str.toLowerCase();
        },

        formatInt: function(int) {
            if (!int) {
                return 0;
            }

            return parseInt(int, 10);
        },

        formatUSD: function(cents) {
            if (!cents) {
                return 0.00;
            }

            const c = parseInt(cents, 10);
            const displayDollars = Math.floor(c/100);
            let displayCents = c % 100;
            if (displayCents < 10) {
                displayCents = `${displayCents}0`;
            }
            return `${displayDollars}.${displayCents}`;
        },

        formatDate: function(date) {
            if (!date) {
                return 0;
            }

            return Moment(date).valueOf();
        },

        noFormat: function(input) {
            return input;
        },

        sortObjectArray: function(objArr, sortObj, options) {
            options = options || {};
            const order = sortObj.asc ? 'asc' : 'desc';
            let formatFxn;
            switch (sortObj.type) {
                case Globals.sort.type.INT:
                    formatFxn = this.formatInt;
                    break;

                case Globals.sort.type.STRING:
                    formatFxn = this.formatString;
                    break;

                case Globals.sort.type.DATE:
                    formatFxn = this.formatDate;
                    break;

                case Globals.sort.type.CURRENCY:
                    formatFxn = this.formatUSD;
                    break;

                default:
                    formatFxn = this.noFormat;
                    break;
            }

            const sortedArr = orderBy(objArr, (row) => {
                let value = get(row, sortObj.key); // key can be an object 'path'
                if (!value && sortObj.alt_key) {
                    value = get(row, sortObj.alt_key);
                }

                if (!!sortObj.override_key) {
                    const val = get(row, sortObj.override_key);
                    if (typeof val !== 'undefined' && val !== null) value = val;
                }

                if (!!options.preFormatFxn) {
                    value = options.preFormatFxn(value);
                }

                return formatFxn(value);
            }, order);

            return sortedArr;
        },

        /* getDefaultSortObjStr
           - create a default sort object for a string key using key = keyName param (default is 'name')
        */
        getDefaultSortObjStr: function(keyName) {
            return {
                type: Globals.sort.type.STRING,
                asc: true,
                key: keyName || 'name'
            };
        },

        updateSortObj: function(currentSortObj, key, type, alt_key, override_key) {
            let sortAsc;
            if (currentSortObj.key === key) {
                sortAsc = !currentSortObj.asc;
            }
            else {
                switch (type) {
                    case Globals.sort.type.INT:
                    case Globals.sort.type.DATE:
                    case Globals.sort.type.CURRENCY:
                        sortAsc = false;
                        break;
                    case Globals.sort.type.STRING:
                    default:
                        sortAsc = true;
                }
            }

            return {
                type: type,
                asc: sortAsc,
                key: key,
                alt_key: alt_key,
                override_key: override_key,
            };
        },

        sortObjUsesKey: function(sortObj, key) {
            if (sortObj && sortObj.key && sortObj.key === key) {
                return true;
            }

            return false;
        },

        sortObjIsAsc: function(sortObj) {
            return sortObj && sortObj.asc;
        },

        // TEMPORARY measure to sort short course licenses (subcompetencies only) by pre-determined name order
        TEMPsortCourseLicenses: function(licenses) {
            const licenseOrders = {
                "Gather and Assess Information": 0,
                "Question Assumptions": 1,
                "Identify Patterns": 2,
                "Draw Conclusions": 3,
            };

            return sortBy(licenses, (license) => {
                return licenseOrders[license.course_title] || 0;
            });
        }
};

module.exports = SortUtil;